import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  useMediaQuery,
  useTheme,
  IconButton,
  Tooltip,
  Stack,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ToggleDrawerContext } from "../../contexts/ToggleDrawer";
import { Cancel, CancelOutlined, Close } from "@mui/icons-material";
import { useIsMobile } from "../../utils/Functions";

export default function CustomDialog({
  children,
  color = "secondary",
  buttonMessage,
  buttonSize,
  closeText,
  disabled,
  buttonVariant = "contained",
  padding = 1,
  maxWidth = "lg",
  mobileIcon,
  showTopCloseButton = false,
  testId,
  ...rest
}) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useContext(ToggleDrawerContext);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = useIsMobile();

  const toggleDialog = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsOpen(open);
  };

  return (
    <>
      {mobileIcon && isMobile ? (
        <Tooltip title={buttonMessage}>
          <IconButton
            aria-label={buttonMessage}
            color={color}
            onClick={toggleDialog(true)}
            disabled={disabled}
            size={buttonSize}
            sx={{ padding: padding }}
            data-testid={testId && `${testId}.trigger`}
          >
            {mobileIcon}
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          variant={buttonVariant}
          color={color}
          onClick={toggleDialog(true)}
          size={buttonSize}
          disabled={disabled}
data-testid={testId && `${testId}.trigger`}
          {...rest}
          sx={{
            padding: padding,
          }}
        >
          {buttonMessage}
        </Button>
      )}
      {isOpen && (
        <Dialog
          open={isOpen}
          onClose={toggleDialog(false)}
          fullScreen={fullScreen}
          maxWidth={maxWidth}
          fullWidth
          data-testid={testId && `${testId}.dialog`}
        >
          <DialogContent sx={{ width: "100%" }}>
            {showTopCloseButton ? (
              <Stack justifyContent={"flex-end"} direction={"row"}>
                <IconButton onClick={toggleDialog(false)} title={t("Close")}>
                  <CancelOutlined color="error" />
                </IconButton>
              </Stack>
            ) : null}
            <Box sx={{ width: "100%" }}>{children}</Box>
          </DialogContent>
          {closeText && (
            <DialogActions>
              <Button
                variant="contained"
                color="error"
                onClick={toggleDialog(false)}
              >
                {closeText}
              </Button>
            </DialogActions>
          )}
        </Dialog>
      )}
    </>
  );
}

export function IconButtonDialog({
  children,
  color = "secondary",
  icon,
  buttonSize,
  closeText,
  disabled,
  buttonVariant = "contained",
  padding = 1,
  ...rest
}) {
  const [isOpen, setIsOpen] = React.useContext(ToggleDrawerContext);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const toggleDialog = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsOpen(open);
  };

  return (
    <>
      <IconButton
        variant={buttonVariant}
        color={color}
        onClick={toggleDialog(true)}
        size={buttonSize}
        disabled={disabled}
        {...rest}
        sx={{
          padding: padding,
        }}
      >
        {icon}
      </IconButton>
      {isOpen && (
        <Dialog
          open={isOpen}
          onClose={toggleDialog(false)}
          fullScreen={fullScreen}
          maxWidth="lg"
          fullWidth
        >
          <DialogContent sx={{ width: "100%" }}>
            <Box sx={{ width: "100%" }}>{children}</Box>
          </DialogContent>
          {closeText && (
            <DialogActions>
              <Button
                variant="contained"
                color="error"
                onClick={toggleDialog(false)}
              >
                {closeText}
              </Button>
            </DialogActions>
          )}
        </Dialog>
      )}
    </>
  );
}
